import React from 'react';
import { Box, Typography, TextField, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import RightArrowIcon from '../icons/right_arrow.svg';

const SearchContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

const SearchField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: 8,
    fontSize: '0.875rem',
  },
}));

const ImpersonateButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#6B46C1',
  color: '#FFFFFF',
  borderRadius: 8,
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '0.875rem',
  padding: '8px 16px',
  '&:hover': {
    backgroundColor: '#553C9A',
  },
}));

const CompanyList = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

const CompanyItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(1, 0),
  borderBottom: '1px solid #E2E8F0',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: '#F7FAFC',
  },
  '&:last-child': {
    borderBottom: 'none',
  },
}));

const CompanyName = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  color: '#4A5568',
  fontWeight: 500,
}));

const ArrowIcon = styled('img')(({ theme }) => ({
  width: 12,
  height: 12,
  opacity: 0.6,
}));

const UsersCompanies: React.FC = () => {
  const companies = [
    'Acme Properties, Inc.',
    'marktenantatenant.com',
  ];

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 600, color: '#1A202C', mb: 2 }}>
        Users & Companies
      </Typography>
      
      <SearchContainer>
        <SearchField
          fullWidth
          placeholder="Impersonate User"
          variant="outlined"
          size="small"
          sx={{ mb: 1 }}
        />
        <ImpersonateButton fullWidth>
          Impersonate
        </ImpersonateButton>
      </SearchContainer>
      
      <CompanyList>
        {companies.map((company, index) => (
          <CompanyItem key={index}>
            <CompanyName>{company}</CompanyName>
            <ArrowIcon src={RightArrowIcon} alt="View" />
          </CompanyItem>
        ))}
      </CompanyList>
    </Box>
  );
};

export default UsersCompanies; 